<template>
  <div style="background-color: #1C1632">
    <div class="cash-giveaway-container">
      <div class="title">BHAI88 CASH GIVEAWAY</div>
      <v-row no-gutters class="container">
        <v-col cols="12" class="pa-0 " :class="$vuetify.breakpoint.mdAndUp ? 'd-flex' : ''">
          <v-col lg="6" sm="12" md="12" class="image-container pa-0">
            <img loading="lazy" src="/static/image/home/clock-timer.png" alt="timer" />
          </v-col>
          <v-col lg="6" sm="12" md="12" class="leaderboard pa-0">
            <div class="entry gold">
              <img loading="lazy" src="/static/image/home/gold_medal.png" alt="medal" />
              <span>Hu******872</span>
              <span>188,888</span>
            </div>
            <div class="entry silver">
              <img loading="lazy" src="/static/image/home/silver_medal.png" alt="medal" />
              <span>AY******IN</span>
              <span>88,888</span>
            </div>
            <div class="entry bronze">
              <img loading="lazy" src="/static/image/home/bronze_medal.png" alt="medal" />
              <span>Ki******et</span>
              <span>38,888</span>
            </div>
            <div class="view-results">
              <button class="view-results-btn">View More Result</button>
              <span>Current Result taken on 4 Sep 2023</span>
            </div>
          </v-col>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'appEarnRewards'
}
</script>

<style lang="scss">
.cash-giveaway-container {
  max-width: 1240px;
  margin: auto;
  padding: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: white;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
  }
  .image-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image-container img {
    max-width: 100%;
    height: auto;
    border-radius: 10px;
  }
  .leaderboard {
    flex: 1;
    padding: 20px;
    color: white;
  }
  .leaderboard h2 {
    margin-bottom: 20px;
  }
  .leaderboard .entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin: 12px 0;
    border-radius: 5px;
    font-size: 18px;
  }
  .gold {
    background-color: #e09d18;
    border: 1px solid #ffd440;
  }
  .silver {
    background-color: #c2c3ca;
    border: 1px solid #eeeff4;
  }
  .bronze {
    background-color: #a34f1f;
    border: 1px solid #e09d18;
  }
  .view-results {
    display: flex;
    align-content: center;

    .view-results-btn {
      background: #ffc000;
      color: black;
      padding: 10px 15px;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      margin-top: 10px;
    }

    span {
      text-transform: capitalize;
      margin-left: 12px;
      font-size: 12px;
      align-content: center;
    }
  }
}
</style>
